import Dashboard from './components/Dashboard.vue'

export default Dashboard
